<template lang="pug">
    div  
        .card-body.bg-light
            .form-row
                .col-md-3.col-sm-12
                    label Nombre Tipo
                    select.form-control.form-control-sm(v-if="tablaInfoShow", v-model="parameter.IdDocType")
                        option(v-for="(item,index) in tablaInfoShow", :value="item.IdDocType") {{item.Name}}  
                .col-md-4.col-sm-12
                    label Nombre Tipo
                    input.form-control.form-control-sm(v-model="parameter.Name", @keypress.enter="sendSearch()")
                .col-md-3.col-sm-12
                    label Estado
                    select.form-control.form-control-sm(v-model="parameter.Active" )
                        option(value=1) Activa
                        option(value=0) Inactiva
                        option(value=2) Todos
                .col-md-2.col-sm-12
                    label 
                    button.btn.btn-primary.text-light.btn-block(@click="sendSearch()") Buscar 
                        i.fa.fa-search  
        .card-body.bg-light    
            .form-group
                    v-simple-table(class="elevation-5" )
                        thead(class="elevation-1"  )
                            tr
                            th Editar
                            th Nombre Tipo 
                            th Activar Preguntas
                            th Activar Respuesta No Conformidades
                            th Estado                        
                        tbody.bg-white(name="table-fade", is="transition-group") 
                            tr(v-if="",v-bind:key="index" v-for="(item,index) in tablaInfo")
                                td
                                    button.btn.btn-sm.btn-info(@click="sendInfo(item)")  
                                        i.fa.fa-edit 
                                td {{item.Name}} 
                                td {{item.ActiveQuestions==1 ? 'Activo':'Inactivo'}}
                                td {{item.ActiveAnswerNonconformities==1 ? 'Activo':'Inactivo'}}
                                td {{item.Active==1 ? 'Activo':'Inactivo'}}

</template>
<script> 
export default {
    props:{
        tablaInfo:Array,
        parameter:Object,
        tablaInfoShow:Array
    }, 
    methods:{ 
            sendSearch(){ 
                this.$emit("update:parameter",this.parameter) 
                this.$emit("sendSearch",this.parameter) 
            },
            sendInfo(item){  
                this.$emit("sendInfo", Object.assign({}, item)) 
            }
    }
}
</script>
<style>
    .table-fade-enter-active {
      transition: all .5s ease;
    }
    .table-fade-leave-active {
      transition: all .5s ease;
    }
    .table-fade-enter, .table-fade-leave-to{
      transform: translateY(-20px);
      opacity: 0;
    } 
</style>